import React from 'react';

import { COMPONENT_BASE_CLASS } from '../constants';

function Divider() {
  return <hr className={`${COMPONENT_BASE_CLASS}__divider`} />;
}

export default Divider;
